import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronDown from '@/icons/SiChevronDown';
import SiChevronUp from '@/icons/SiChevronUp';

import { Button } from '@/components/form/Button';
import { FinanceModel, PeripheralFinanceModel } from '@/services/api/contracts/financemodels';
import { GroupedFinanceModelsByCategoriesAndManufacturers } from '@/services/catalogue/useGroupFinanceModels';
import { FunctionComponent, useState } from 'react';
import { FinanceModelCard } from './FinanceModelCard';
import { PeripheralFinanceModelCard } from './PeripheralFinanceModelCard';

interface FinanceModelsSectionProps {
  infoText?: string;
  group: GroupedFinanceModelsByCategoriesAndManufacturers;
  peripheralModels?: PeripheralFinanceModel[];
  defaultExpanded?: boolean;
  active?: boolean;
}

const FinanceModelsSection: FunctionComponent<FinanceModelsSectionProps> = ({
  infoText,
  group,
  peripheralModels,
  defaultExpanded = true,
  active
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const listOfCategoryObjects = Object.values(group);
  const financeModelLists: FinanceModel[][] = listOfCategoryObjects.reduce(
    (prevList, currentValue) => {
      return [...prevList, ...Object.entries(currentValue).map(e => e[1])];
    },
    [] as FinanceModel[][]
  );

  return (
    <div className="space-y-1">
      <div className="font-semibold flex items-center">
        <Button className="text-4xl p-0" variant={ButtonVariant.Ghost} onClick={() => setExpanded(!expanded)}>
          {expanded ? <SiChevronUp /> : <SiChevronDown />}
        </Button>
        <p className="text-xl">{`${active ? 'Active' : 'Inactive'} (${
          financeModelLists.length + (peripheralModels ? 1 : 0)
        })`}</p>
      </div>

      {expanded && (
        <div className="space-y-1">
          {infoText && <p className="font-semibold pb-2">{infoText}</p>}
          <div className="space-y-2">
            {financeModelLists.map((models, index) => (
              <FinanceModelCard
                models={models}
                key={models.length > 0 ? `${models[0].categoryId}.${models[0].manufacturerId}` : index}
              />
            ))}
            {peripheralModels && <PeripheralFinanceModelCard models={peripheralModels} />}
          </div>
        </div>
      )}
    </div>
  );
};

export default FinanceModelsSection;
